const comments = [
  {
    name: '电影爱好者小王',
    text: '用了白云视频好几个月了，画质是真的好！和苹果视频比起来资源也很全，追剧体验非常流畅。强烈推荐给喜欢手机看片的朋友。',
    time: '3天前',
    rating: 5,
  },
  {
    name: '追剧达人Lily',
    text: '之前一直用榴莲视频，后来朋友推荐了白云视频。界面简洁清爽，广告也少，而且更新速度真的快，新剧基本同步上线，太给力了！',
    time: '5天前',
    rating: 5,
  },
  {
    name: '动漫控阿杰',
    text: '动漫资源非常丰富，新番更新及时，画质清晰。离线缓存功能很好用，通勤路上看番再也不用担心流量了。',
    time: '1周前',
    rating: 4,
  },
  {
    name: '综艺迷小陈',
    text: '周末必刷白云视频的综艺专区！热门综艺更新快，弹幕氛围也欢乐。比桃子视频体验好，没有乱七八糟的广告弹窗。',
    time: '2周前',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-chat-smile-2-line"></i>
            <span className="whitespace-nowrap">真实反馈</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">用户怎么说</h2>
          <p className="mt-2 text-sm text-foreground-500">来自白云视频用户的真实评价</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="p-5 rounded-xl bg-background-50 border border-background-200/60"
            >
              <div className="flex items-center gap-1.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-fill text-sm ${i < comment.rating ? 'text-accent-500' : 'text-background-200'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
              <div className="mt-3 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold">
                    {comment.name.charAt(0)}
                  </div>
                  <span className="text-xs font-medium text-foreground-800">{comment.name}</span>
                </div>
                <span className="text-xs text-foreground-400">{comment.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}